import { render, staticRenderFns } from "./PlacementsList.vue?vue&type=template&id=d99dc9c6"
import script from "./PlacementsList.vue?vue&type=script&lang=js"
export * from "./PlacementsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports